import React, { useEffect, useState } from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';

import Form from './Form';
import graph from './graph';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { isEmptyObject } from 'helpers/formatObject';
import { useLazyQuery, useMutation } from '@apollo/client';
import { NewDialog, NewDialogTitle, NewDialogContent, NewDialogActions } from 'components';
import { digitsFaToEn } from '@persian-tools/persian-tools';

export default function UpdatePopup({ ids, refetch, title = 'پکیج' }) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [formError, setFormError] = useState(true);
  const { userToken } = useSelector((state) => state.auth);
  const [fetchModel, { loading }] = useLazyQuery(graph.get.query);
  const [updateModel, { loading: updating }] = useMutation(graph.update.query);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const getModel = async () => {
    try {
      const { data } = await fetchModel({
        context: {
          serviceName: graph.get.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          ids,
          for_admin: 1,
        },
      });
      if (!isEmptyObject(data)) {
        const res = data[graph.get.name].data[0];
        const { shop, booth, product_info, is_active, stock, co_price, me_price, max_number_buy, nonexistent_number } =
          res;
        const { id, title, barcode, brand, category, introtext, packaged_items } = product_info;
        if (res) {
          setFormData({
            id,
            title,
            introtext,
            is_active,
            brand_id: brand?.id,
            category_id: category?.id,
            barcode: Number(barcode),
            packaged_items: packaged_items.map((x) => ({
              product_shop_id: String(x?.product_shop?.id),
              quantity: Number(digitsFaToEn(x?.quantity)),
            })),

            shop_id: shop?.id,
            booth_id: booth?.id,
            stock: Number(stock),
            co_price: Number(co_price),
            me_price: Number(me_price),
            max_number_buy: Number(max_number_buy),
            nonexistent_number: Number(nonexistent_number),
          });
        }
      }
    } catch (error) {}
  };

  const onChange = ({ formData, errors }) => {
    console.log(formData);
    setFormData((prev) => ({ ...prev, ...formData }));
    setFormError(Boolean(errors.length > 0));
  };

  const onSubmit = async () => {
    try {
      const { data, errors } = await updateModel({
        context: {
          serviceName: graph.update.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          // ...formData,
          // product_id:,
          product_shop_id: ids,
          product_id: formData?.id,

          title: formData?.title,
          shop_id: formData?.shop_id,
          booth_id: formData?.booth_id,
          brand_id: formData?.brand_id,
          category_id: formData?.category_id,
          
          // co_price: String(formData?.co_price),
          me_price: String(formData?.me_price),
          stock: String(formData?.stock),
          max_number_buy: String(formData?.max_number_buy),
          nonexistent_number: String(formData?.nonexistent_number),
          
          is_active: formData?.is_active,
          introtext: formData?.introtext,
          barcode: String(formData?.barcode),
          packaged_items: formData?.packaged_items,
        },
      });
      if (!errors) {
        refetch();
        onClose();
        if (!isEmptyObject(data)) {
          data[graph.update.name]?.messages.map((message) => toast.success(String(message)));
        }
      }
    } catch (error) {
      setFormData(formData);
    }
  };

  useEffect(() => {
    open && getModel();
  }, [open]);

  return (
    <>
      <Button
        onClick={onOpen}
        size="small"
        color="primary"
        variant="contained"
        startIcon={<ListAltRoundedIcon fontSize="small" />}
      >
        {title}
      </Button>
      <NewDialog label="update" open={open} onClose={onClose}>
        <NewDialogTitle title={title} onClose={onClose} />
        <NewDialogContent isPopup>
          <Stack p={1} flex={2} rowGap={1} bgcolor="background.paper">
            {loading ? (
              <Stack rowGap={2} height="100%" alignItems="center" justifyContent="center">
                <CircularProgress size={20} color="inherit" />
                <Typography align="center" variant="caption" color="text.disabled">
                  در حال بارگذاری...
                </Typography>
              </Stack>
            ) : (
              <Form formData={formData} onChange={onChange} />
            )}
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          <Button
            autoFocus
            size="large"
            color="primary"
            variant="contained"
            onClick={onSubmit}
            sx={{ minWidth: 80 }}
            disabled={loading || updating || formError}
          >
            <FormattedMessage id="update" />
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
